import {
  apiClient,
  decoded,
  ImageUtil,
} from '../../utils';
import { setBaseData } from '../slice/SelectedSlice';
import Config from "../../utils/Config";

import { createApiAction } from './createApiAction';
 
export const SUCCESS_MESSAGE = 'SUCCESS_MESSAGE'
export const ERROR_MESSAGE = 'ERROR_MESSAGE'
export const IS_LOADING = 'IS_LOADING'
export const LOGOUT = 'LOGOUT'

export const MENU_LIST = 'MENU_LIST'
export const AUTHORIZATION_LIST = 'AUTHORIZATION_LIST'
export const AUTHORIZATION_MENU_LIST = 'AUTHORIZATION_MENU_LIST'
export const AUTHORIZATION_SUB_MENU_LIST = 'AUTHORIZATION_SUB_MENU_LIST'

export const FORM_LIST = 'FORM_LIST'
export const FORM_DATA = 'FORM_DATA'
export const OBJECT_DATA = 'OBJECT_DATA'
export const OBJECT_LIST = 'OBJECT_LIST'
export const SELECT_BOX_LIST = 'SELECT_BOX_LIST'

export const PACKAGE_LIST = 'PACKAGE_LIST'
export const PACKAGE_DATA = 'PACKAGE_DATA'

export const COMPANY_LIST = 'COMPANY_LIST'
export const COMPANY_DATA = 'COMPANY_DATA'
export const BRANCH_LIST = 'BRANCH_LIST'
export const BRANCH_DATA = 'BRANCH_DATA'

export const TAX_LIST = 'TAX_LIST'
export const TAX_SELECTBOX_LIST = 'TAX_SELECTBOX_LIST'
export const CATEGORY_SELECTBOX_LIST = 'CATEGORY_SELECTBOX_LIST'
export const CATEGORY_LIST = 'CATEGORY_LIST'
export const CATEGORY_DATA = 'CATEGORY_DATA'
export const SUB_CATEGORY_SELECTBOX_LIST = 'SUB_CATEGORY_SELECTBOX_LIST'
export const SUB_CATEGORY_LIST = 'SUB_CATEGORY_LIST'
export const SUB_CATEGORY_DATA = 'SUB_CATEGORY_DATA'

export const STAFF_SELECTBOX_LIST = 'STAFF_SELECTBOX_LIST'
export const STAFF_LIST = 'STAFF_LIST'
export const STAFF_DATA = 'STAFF_DATA'
export const USER_LIST = 'USER_LIST'
export const USER_DATA = 'USER_DATA'
export const CUSTOMER_LIST = 'CUSTOMER_LIST'
export const CUSTOMER_DATA = 'CUSTOMER_DATA'
export const AUTO_SUGGESSTION_LIST = 'AUTO_SUGGESSTION_LIST'
export const ID_SETTING_LIST = 'ID_SETTING_LIST'
export const MAIL_SETTING_LIST = 'MAIL_SETTING_LIST'
export const MAIL_SENT_LIST = 'MAIL_SENT_LIST'
export const STATUS_TYPE_LIST = 'STATUS_TYPE_LIST'
export const ENQUIRY_LIST = 'ENQUIRY_LIST'
export const ENQUIRY_DATA = 'ENQUIRY_DATA'
export const WEB_ENQUIRY_LIST = 'WEB_ENQUIRY_LIST'
export const WEB_ENQUIRY_DATA = 'WEB_ENQUIRY_DATA'

export const ITEM_LIST = 'ITEM_LIST'
export const ITEM_DATA = 'ITEM_DATA'
export const ITEM_SUGGESSTIONS = 'ITEM_SUGGESSTIONS'

export const QUOTATION_LIST = 'QUOTATION_LIST'
export const QUOTATION_DATA = 'QUOTATION_DATA'
export const PURCHASE_LIST = 'PURCHASE_LIST'
export const PURCHASE_DATA = 'PURCHASE_DATA'
export const SALE_LIST = 'SALE_LIST'
export const SALE_DATA = 'SALE_DATA'
export const DELIVERY_CHALLLAN_LIST = 'DELIVERY_CHALLLAN_LIST'
export const DELIVERY_CHALLLAN_DATA = 'DELIVERY_CHALLLAN_DATA'

export const FOOD_ORDER_LIST = 'FOOD_ORDER_LIST'
export const FOOD_ORDER_DATA = 'FOOD_ORDER_DATA'
export const FOOD_ORDER_STATUS_LIST = 'FOOD_ORDER_STATUS_LIST'

export const FOOD_ITEM_LIST = 'FOOD_ITEM_LIST'
export const FOOD_ITEM_DATA = 'FOOD_ITEM_DATA'

export const BANNER_LIST = 'BANNER_LIST'
export const RATINGS_LIST = 'RATINGS_LIST'
export const DELIVERY_CHARGES_LIST = 'DELIVERY_CHARGES_LIST'

export const BANK_LIST = 'BANK_LIST'
export const MAIL_TEMPLATE_LIST = 'MAIL_TEMPLATE_LIST'

export const RECEIPT_LIST = 'RECEIPT_LIST'
export const RECEIPT_DATA = 'RECEIPT_DATA'

export const OUTSTANDING_RECEIVABLE_LIST = 'OUTSTANDING_RECEIVABLE_LIST'
export const OUTSTANDING_PAYABLE_LIST = 'OUTSTANDING_PAYABLE_LIST'

export const CUSTOMER_ADDRESS_LIST = 'CUSTOMER_ADDRESS_LIST'

export const STOCK_LIST = 'STOCK_LIST'

export const DEVICE_LIST = "DEVICE_LIST";
export const DESIGN_LIST = "DESIGN_LIST";
export const DEVICE_STATUS_DATA = "DEVICE_STATUS_DATA";

export const empty_message = () => {
  return (dispatch) => {
    dispatch({ type: 'SUCCESS_MESSAGE', payload: '' })
    dispatch({ type: 'ERROR_MESSAGE', payload: '' })
    return true
  }
}

export const logout = () => {
  return (dispatch) => {
    dispatch({ type: 'LOGOUT', payload: '' })
    return true
  }
}

export const GetSelectBoxList = (formData) =>
  createApiAction({ url: '/buskes/GetSelectBoxList', method: 'get', formData, type: 'SELECT_BOX_LIST', useDecoded: true });

export const SignUpAction = (formData) =>
  createApiAction({ url: '/buskes/SignUpAction', method: 'post', formData, type: 'SUCCESS_MESSAGE', isPost: true });


export const SignInAction = (formData) => {
  return (dispatch) => {
    apiClient
      .post('/buskes/SignInAction', formData, {
        headers: Config.getHeaders()
      })
      .then((responseJson) => {
        if (responseJson.data === '') {
          //localStorage.setItem('Authorization', '')
        }
        dispatch({ type: 'SUCCESS_MESSAGE', payload: 'SignInAction' })
        dispatch({ type: 'ERROR_MESSAGE', payload: '' })
        let res = decoded(responseJson.data)
        if (res?.message === 'SUCCESS') {
          dispatch(setBaseData(res));
          localStorage.setItem('company_id_1', res?.company_id)
          localStorage.setItem('company_name_1', res?.company_name)
          localStorage.setItem('company_logo_1', res?.company_logo || ImageUtil.companyAvatar)
          localStorage.setItem('branch_id_1', res?.branch_id)
          localStorage.setItem('branch_name_1', res?.branch_name)
          localStorage.setItem('branch_location_1', res?.branch_location)
          localStorage.setItem('branch_logo_1', res?.branch_logo || ImageUtil.companyAvatar)
          localStorage.setItem('registration_id', res?.lid)
          localStorage.setItem('lid', res?.lid)
          localStorage.setItem('master_id', res?.master_id)
          localStorage.setItem('entity_id', res?.entity_id)
          localStorage.setItem('login_history_id', res?.login_history_id)
          localStorage.setItem('last_sig', res?.last_sig)
          localStorage.setItem('Authorization', res?.token.toString())
          localStorage.setItem('Authorization1', res?.jwtToken.toString())
          localStorage.setItem('type_of_entity', res?.type_of_entity)
          localStorage.setItem('user_type', res?.user_type)
          localStorage.setItem('first_name', res?.first_name)
          localStorage.setItem('last_name', res?.last_name)
          localStorage.setItem('profile_image', res?.profile_image || ImageUtil.userAvatar)
          localStorage.setItem('role', res?.role)
          localStorage.setItem('resume_text', res?.resume_text)
          localStorage.setItem('resume_file', res?.resume_file)
        } else {
          dispatch({ type: 'ERROR_MESSAGE', payload: res?.message })
        }
        return true
      })
      .catch((error) => {
        dispatch({ type: 'SUCCESS_MESSAGE', payload: 'SignInAction' })
        dispatch({ type: 'ERROR_MESSAGE', payload: error })
      })
    return true
  }
}

export const LoginWithSocialID = (formData) => {
  return (dispatch) => {
    apiClient
      .post('/buskes/LoginWithSocialID', formData, {
        headers: Config.getHeaders()
      })
      .then((responseJson) => {
        if (responseJson.data === '') {
          //localStorage.setItem('Authorization', '')
        }
        dispatch({ type: 'SUCCESS_MESSAGE', payload: 'LoginWithSocialID' })
        let res = decoded(responseJson.data)
        if (res?.message === 'SUCCESS') {
          dispatch(setBaseData(res));
          localStorage.setItem('registration_id', res?.lid)
          localStorage.setItem('lid', res?.lid)
          localStorage.setItem('master_id', res?.master_id)
          localStorage.setItem('entity_id', res?.entity_id)
          localStorage.setItem('login_history_id', res?.login_history_id)
          localStorage.setItem('last_sig', res?.last_sig)
          localStorage.setItem('Authorization', res?.token.toString())
          localStorage.setItem('type_of_entity', res?.type_of_entity)
          localStorage.setItem('user_type', res?.user_type)
          localStorage.setItem('first_name', res?.first_name)
          localStorage.setItem('last_name', res?.last_name)
          localStorage.setItem('profile_image', res?.profile_image)
          if (res?.profile_image === '') {
            localStorage.setItem('profile_image', ImageUtil.userAvatar)
          }
          localStorage.setItem('role', res?.role)
          localStorage.setItem('resume_text', res?.resume_text)
          localStorage.setItem('resume_file', res?.resume_file)
        } else {
          dispatch({ type: 'ERROR_MESSAGE', payload: res?.message })
        }
        return true
      })
      .catch((error) => {
        dispatch({ type: 'SUCCESS_MESSAGE', payload: 'LoginWithSocialID' })
        dispatch({ type: 'ERROR_MESSAGE', payload: error })
      })
    return true
  }
}

export const RefreshToken = (formData) =>
  createApiAction({ url: '/buskes/RefreshToken', method: 'post', formData, type: 'SUCCESS_MESSAGE', isPost: true, storeToken : true });

export const LogOutAction = (formData) =>
  createApiAction({ url: '/buskes/LogOutAction', method: 'post', formData, type: 'SUCCESS_MESSAGE', isPost: true });

export const ChangePasswordAction = (formData) =>
  createApiAction({ url: '/buskes/ChangePasswordAction', method: 'post', formData, type: 'SUCCESS_MESSAGE', isPost: true });

export const GetResetPasswordLinkByMail = (formData) =>
  createApiAction({ url: '/buskes/GetResetPasswordLinkByMail', method: 'post', formData, type: 'SUCCESS_MESSAGE', isPost: true });

export const MailVerification = (formData) =>
  createApiAction({ url: '/buskes/MailVerification', method: 'post', formData, type: 'SUCCESS_MESSAGE', isPost: true });

export const GenericUpdate = (formData) =>
  createApiAction({ url: '/buskes/GenericUpdate', method: 'post', formData, type: 'SUCCESS_MESSAGE', isPost: true });

export const GetMenuList = (formData) =>
  createApiAction({ url: '/buskes/GetMenuList', method: 'get', formData, type: 'MENU_LIST', useDecoded: true });

export const AddMenu = (formData) =>
  createApiAction({ url: '/buskes/AddMenu', method: 'post', formData, type: 'SUCCESS_MESSAGE', isPost: true });

export const GetAuthorizationListByRegistrationId = (formData) =>
  createApiAction({ url: '/buskes/GetAuthorizationListByRegistrationId', method: 'get', formData, type: 'AUTHORIZATION_LIST', useDecoded: true });

export const GetMenuDataByRegistrationId = (formData) =>
  createApiAction({ url: '/buskes/GetMenuDataByRegistrationId', method: 'get', formData, type: 'AUTHORIZATION_MENU_LIST', useDecoded: true });

export const GetSubMenuData = (formData) =>
  createApiAction({ url: '/buskes/GetSubMenuData', method: 'get', formData, type: 'AUTHORIZATION_SUB_MENU_LIST', useDecoded: true });

export const AddAuthorization = (formData) =>
  createApiAction({ url: '/buskes/AddAuthorization', method: 'post', formData, type: 'SUCCESS_MESSAGE', isPost: true });

export const clearFormData = () => ({
  type: 'CLEAR_FORM'
});

export const AddFormConfig = (formData) =>
  createApiAction({ url: '/buskes/AddFormConfig', method: 'post', formData, type: 'SUCCESS_MESSAGE', isPost: true });

export const AddFormColumn = (formData) =>
  createApiAction({ url: '/buskes/AddFormColumn', method: 'post', formData, type: 'SUCCESS_MESSAGE', isPost: true });

export const AddFormSection = (formData) =>
  createApiAction({ url: '/buskes/AddFormSection', method: 'post', formData, type: 'SUCCESS_MESSAGE', isPost: true });

export const AddFormField = (formData) =>
  createApiAction({ url: '/buskes/AddFormField', method: 'post', formData, type: 'SUCCESS_MESSAGE', isPost: true });

export const GetFormConfig = (formData) =>
  createApiAction({ url: '/buskes/GetFormConfig', method: 'get', formData, type: 'FORM_DATA', useDecoded: true });

export const GetFormConfigList = (formData) =>
  createApiAction({ url: '/buskes/GetFormConfigList', method: 'get', formData, type: 'FORM_LIST', useDecoded: true });

export const GetAllObjectJsonData = (formData) =>
  createApiAction({ url: '/buskes/GetAllObjectJsonData', method: 'get', formData, type: 'OBJECT_LIST', useDecoded: true });

export const GetObjectJsonData = (formData) =>
  createApiAction({ url: '/buskes/GetObjectJsonData', method: 'get', formData, type: 'OBJECT_DATA', useDecoded: true });

export const AddPackage = (formData) =>
  createApiAction({ url: '/buskes/AddPackage', method: 'post', formData, type: 'SUCCESS_MESSAGE', isPost: true });

export const GetPackageList = (formData) =>
  createApiAction({ url: '/buskes/GetPackageList', method: 'get', formData, type: 'PACKAGE_LIST', useDecoded: true });

export const GetPackageData = (formData) =>
  createApiAction({ url: '/buskes/GetPackageData', method: 'get', formData, type: 'PACKAGE_DATA', useDecoded: true });

export const clearCompanyData = () => ({
  type: 'CLEAR_COMPANY'
});

export const AddCompany = (formData) =>
  createApiAction({ url: '/buskes/AddCompany', method: 'post', formData, type: 'SUCCESS_MESSAGE', isPost: true });

export const GetCompanyData = (formData) =>
  createApiAction({ url: '/buskes/GetCompanyData', method: 'get', formData, type: 'COMPANY_DATA', useDecoded: true });

export const GetCompanyListByPagination = (formData) =>
  createApiAction({ url: '/buskes/GetCompanyListByPagination', method: 'get', formData, type: 'COMPANY_LIST', useDecoded: true });

export const clearBranchData = () => ({
  type: 'CLEAR_BRANCH'
});

export const AddBranch = (formData) =>
  createApiAction({ url: '/buskes/AddBranch', method: 'post', formData, type: 'SUCCESS_MESSAGE', isPost: true });

export const GetBranchData = (formData) =>
  createApiAction({ url: '/buskes/GetBranchData', method: 'get', formData, type: 'BRANCH_DATA', useDecoded: true });

export const GetBranchListByPagination = (formData) =>
  createApiAction({ url: '/buskes/GetBranchListByPagination', method: 'get', formData, type: 'BRANCH_LIST', useDecoded: true });

export const AddCategory = (formData) =>
  createApiAction({ url: '/buskes/AddCategory', method: 'post', formData, type: 'SUCCESS_MESSAGE', isPost: true });

export const GetCategoryList = (formData) =>
  createApiAction({ url: '/buskes/GetCategoryList', method: 'get', formData, type: 'CATEGORY_LIST', useDecoded: true });

export const GetCategoryData = (formData) =>
  createApiAction({ url: '/buskes/GetCategoryData', method: 'get', formData, type: 'CATEGORY_DATA', useDecoded: true });

// Clear Category Data
export const clearCategoryData = () => ({
  type: 'CLEAR_CATEGORY'
});

export const GetCategorySelectBoxList = (formData) =>
  createApiAction({ url: '/buskes/GetCategorySelectBoxList', method: 'get', formData, type: 'CATEGORY_SELECTBOX_LIST', useDecoded: true });

export const AddSubCategory = (formData) =>
  createApiAction({ url: '/buskes/AddSubCategory', method: 'post', formData, type: 'SUCCESS_MESSAGE', isPost: true });

export const GetSubCategoryList = (formData) =>
  createApiAction({ url: '/buskes/GetSubCategoryList', method: 'get', formData, type: 'SUB_CATEGORY_LIST', useDecoded: true });

export const GetSubCategoryData = (formData) =>
  createApiAction({ url: '/buskes/GetSubCategoryData', method: 'get', formData, type: 'SUB_CATEGORY_DATA', useDecoded: true });

export const GetSubCategorySelectBoxList = (formData) =>
  createApiAction({ url: '/buskes/GetSubCategorySelectBoxList', method: 'get', formData, type: 'SUB_CATEGORY_SELECTBOX_LIST', useDecoded: true });

// Clear Sub Category Data
export const clearSubCategoryData = () => ({
  type: 'CLEAR_SUB_CATEGORY'
});

export const clearCustomerData = () => ({
  type: 'CLEAR_CUSTOMER'
});

export const AddCustomer = (formData) =>
  createApiAction({ url: '/buskes/AddCustomer', method: 'post', formData, type: 'SUCCESS_MESSAGE', isPost: true });

export const GetCustomerListByPagination = (formData) =>
  createApiAction({ url: '/buskes/GetCustomerListByPagination', method: 'get', formData, type: 'CUSTOMER_LIST', useDecoded: true });

export const GetCustomerData = (formData) =>
  createApiAction({ url: '/buskes/GetCustomerData', method: 'get', formData, type: 'CUSTOMER_DATA', useDecoded: true });

export const GetAutoSuggestions = (formData) =>
  createApiAction({ url: '/buskes/GetAutoSuggestions', method: 'get', formData, type: 'AUTO_SUGGESSTION_LIST', useDecoded: true });

export const clearStaffData = () => ({
  type: 'CLEAR_STAFF'
});

export const AddStaff = (formData) =>
  createApiAction({ url: '/buskes/AddStaff', method: 'post', formData, type: 'SUCCESS_MESSAGE', isPost: true });

export const GetStaffListByPagination = (formData) =>
  createApiAction({ url: '/buskes/GetStaffListByPagination', method: 'get', formData, type: 'STAFF_LIST', useDecoded: true });

export const GetStaffData = (formData) =>
  createApiAction({ url: '/buskes/GetStaffData', method: 'get', formData, type: 'STAFF_DATA', useDecoded: true });

export const AddIdSetting = (formData) =>
  createApiAction({ url: '/buskes/AddIdSetting', method: 'post', formData, type: 'SUCCESS_MESSAGE', isPost: true });

export const GetIdSettingList = (formData) =>
  createApiAction({ url: '/buskes/GetIdSettingList', method: 'get', formData, type: 'ID_SETTING_LIST', useDecoded: true });

export const AddStatusType = (formData) =>
  createApiAction({ url: '/buskes/AddStatusType', method: 'post', formData, type: 'SUCCESS_MESSAGE', isPost: true });

export const GetStatusTypeList = (formData) =>
  createApiAction({ url: '/buskes/GetStatusTypeList', method: 'get', formData, type: 'STATUS_TYPE_LIST', useDecoded: true });

export const clearUserData = () => ({
  type: 'CLEAR_USER'
});

export const GetUserListByPagination = (formData) =>
  createApiAction({ url: '/buskes/GetUserListByPagination', method: 'get', formData, type: 'USER_LIST', useDecoded: true });

export const GetUserData = (formData) =>
  createApiAction({ url: '/buskes/GetUserData', method: 'get', formData, type: 'USER_DATA', useDecoded: true });

export const AddTaxSetting = (formData) =>
  createApiAction({ url: '/buskes/AddTaxSetting', method: 'post', formData, type: 'SUCCESS_MESSAGE', isPost: true });

export const GetTaxSettingList = (formData) =>
  createApiAction({ url: '/buskes/GetTaxSettingList', method: 'get', formData, type: 'TAX_LIST', useDecoded: true });

export const GetTaxSettingSelectBoxList = (formData) =>
  createApiAction({ url: '/buskes/GetTaxSettingSelectBoxList', method: 'get', formData, type: 'TAX_SELECTBOX_LIST', useDecoded: true });

export const clearItemData = () => ({
  type: 'CLEAR_ITEM'
});

export const AddItem = (formData) =>
  createApiAction({ url: '/buskes/AddItem', method: 'post', formData, type: 'SUCCESS_MESSAGE', isPost: true });

export const GetItemListByPagination = (formData) =>
  createApiAction({ url: '/buskes/GetItemListByPagination', method: 'get', formData, type: 'ITEM_LIST', useDecoded: true });

export const GetItemData = (formData) =>
  createApiAction({ url: '/buskes/GetItemData', method: 'get', formData, type: 'ITEM_DATA', useDecoded: true });

export const GetItemStockData = (formData) =>
  createApiAction({ url: '/buskes/GetItemStockData', method: 'get', formData, type: 'ITEM_DATA', useDecoded: true });

export const clearEnquiryData = () => ({
  type: 'CLEAR_ENQUIRY'
});

export const AddEnquiry = (formData) =>
  createApiAction({ url: '/buskes/AddEnquiry', method: 'post', formData, type: 'SUCCESS_MESSAGE', isPost: true });

export const GetEnquiryListByPagination = (formData) =>
  createApiAction({ url: '/buskes/GetEnquiryListByPagination', method: 'get', formData, type: 'ENQUIRY_LIST', useDecoded: true });

export const GetEnquiryData = (formData) =>
  createApiAction({ url: '/buskes/GetEnquiryData', method: 'get', formData, type: 'ENQUIRY_DATA', useDecoded: true });

export const clearQuotationData = () => ({
  type: 'CLEAR_QUOTATION'
});

export const AddQuotation = (formData) =>
  createApiAction({ url: '/buskes/AddQuotation', method: 'post', formData, type: 'SUCCESS_MESSAGE', isPost: true });

export const GetQuotationList = (formData) =>
  createApiAction({ url: '/buskes/GetQuotationList', method: 'get', formData, type: 'QUOTATION_LIST', useDecoded: true });

export const GetQuotationData = (formData) =>
  createApiAction({ url: '/buskes/GetQuotationData', method: 'get', formData, type: 'QUOTATION_DATA', useDecoded: true });

export const GetQuotationPreview = (formData) =>
  createApiAction({ url: '/buskes/GetQuotationPreview', method: 'get', formData, type: 'QUOTATION_DATA', useDecoded: true });

export const clearPurchaseData = () => ({
  type: 'CLEAR_PURCHASE'
});

export const AddPurchase = (formData) =>
  createApiAction({ url: '/buskes/AddPurchase', method: 'post', formData, type: 'SUCCESS_MESSAGE', isPost: true });

export const GetPurchaseList = (formData) =>
  createApiAction({ url: '/buskes/GetPurchaseList', method: 'get', formData, type: 'PURCHASE_LIST', useDecoded: true });

export const GetPurchaseData = (formData) =>
  createApiAction({ url: '/buskes/GetPurchaseData', method: 'get', formData, type: 'PURCHASE_DATA', useDecoded: true });

export const clearSaleData = () => ({
  type: 'CLEAR_SALE'
});

export const AddSale = (formData) =>
  createApiAction({ url: '/buskes/AddSale', method: 'post', formData, type: 'SUCCESS_MESSAGE', isPost: true });

export const GetSaleList = (formData) =>
  createApiAction({ url: '/buskes/GetSaleList', method: 'get', formData, type: 'SALE_LIST', useDecoded: true });

export const GetSaleData = (formData) =>
  createApiAction({ url: '/buskes/GetSaleData', method: 'get', formData, type: 'SALE_DATA', useDecoded: true });

export const GetSalePreview = (formData) =>
  createApiAction({ url: '/buskes/GetSalePreview', method: 'get', formData, type: 'SALE_DATA', useDecoded: true });

export const clearDeliveryChallanData = () => ({
  type: 'CLEAR_DELIVERY_CHALLLAN'
});

export const AddDeliveryChallan = (formData) =>
  createApiAction({ url: '/buskes/AddDeliveryChallan', method: 'post', formData, type: 'SUCCESS_MESSAGE', isPost: true });

export const GetDeliveryChallanList = (formData) =>
  createApiAction({ url: '/buskes/GetDeliveryChallanList', method: 'get', formData, type: 'DELIVERY_CHALLLAN_LIST', useDecoded: true });

export const GetDeliveryChallanData = (formData) =>
  createApiAction({ url: '/buskes/GetDeliveryChallanData', method: 'get', formData, type: 'DELIVERY_CHALLLAN_DATA', useDecoded: true });

export const GetDeliveryChallanPreview = (formData) =>
  createApiAction({ url: '/buskes/GetDeliveryChallanPreview', method: 'get', formData, type: 'DELIVERY_CHALLLAN_DATA', useDecoded: true });

export const AddMailSetting = (formData) =>
  createApiAction({ url: '/buskes/AddMailSetting', method: 'post', formData, type: 'SUCCESS_MESSAGE', isPost: true });

export const GetMailSettingList = (formData) =>
  createApiAction({ url: '/buskes/GetMailSettingList', method: 'get', formData, type: 'MAIL_SETTING_LIST', useDecoded: true });

export const AddMailSent = (formData) =>
  createApiAction({ url: '/buskes/AddMailSent', method: 'post', formData, type: 'SUCCESS_MESSAGE', isPost: true });

export const GetMailSentList = (formData) =>
  createApiAction({ url: '/buskes/GetMailSentList', method: 'get', formData, type: 'MAIL_SENT_LIST', useDecoded: true });

export const AddFoodItem = (formData) =>
  createApiAction({ url: '/buskes/AddFoodItem', method: 'post', formData, type: 'SUCCESS_MESSAGE', isPost: true });

export const GetFoodItemList = (formData) =>
  createApiAction({ url: '/buskes/GetFoodItemList', method: 'get', formData, type: 'FOOD_ITEM_LIST', useDecoded: true });

export const clearFoodOrderData = () => ({
  type: 'CLEAR_FOOD_ORDER'
});

export const AddFoodOrder = (formData) =>
  createApiAction({ url: '/buskes/AddFoodOrder', method: 'post', formData, type: 'SUCCESS_MESSAGE', isPost: true });

export const GetFoodOrderList = (formData) =>
  createApiAction({ url: '/buskes/GetFoodOrderList', method: 'get', formData, type: 'FOOD_ORDER_LIST', useDecoded: true });

export const GetFoodOrderData = (formData) =>
  createApiAction({ url: '/buskes/GetFoodOrderData', method: 'get', formData, type: 'FOOD_ORDER_DATA', useDecoded: true });

export const AddOrderStatus = (formData) =>
  createApiAction({ url: '/buskes/AddOrderStatus', method: 'post', formData, type: 'SUCCESS_MESSAGE', isPost: true });

export const GetOrderStatusList = (formData) =>
  createApiAction({ url: '/buskes/GetOrderStatusList', method: 'get', formData, type: 'FOOD_ORDER_STATUS_LIST', useDecoded: true });


export const clearWebEnquiryData = () => ({
  type: 'CLEAR_WEB_ENQUIRY'
});

export const AddWebEnquiry = (formData) =>
  createApiAction({ url: '/buskes/AddWebEnquiry', method: 'post', formData, type: 'SUCCESS_MESSAGE', isPost: true });

export const GetWebEnquiryList = (formData) =>
  createApiAction({ url: '/buskes/GetWebEnquiryList', method: 'get', formData, type: 'WEB_ENQUIRY_LIST', useDecoded: true });

export const GetWebEnquiryData = (formData) =>
  createApiAction({ url: '/buskes/GetWebEnquiryData', method: 'get', formData, type: 'WEB_ENQUIRY_DATA', useDecoded: true });

export const AddBank = (formData) =>
  createApiAction({ url: '/buskes/AddBank', method: 'post', formData, type: 'SUCCESS_MESSAGE', isPost: true });

export const GetBankList = (formData) =>
  createApiAction({ url: '/buskes/GetBankList', method: 'get', formData, type: 'BANK_LIST', useDecoded: true });

export const AddMailTemplate = (formData) =>
  createApiAction({ url: '/buskes/AddMailTemplate', method: 'post', formData, type: 'SUCCESS_MESSAGE', isPost: true });

export const GetMailTemplateList = (formData) =>
  createApiAction({ url: '/buskes/GetMailTemplateList', method: 'get', formData, type: 'MAIL_TEMPLATE_LIST', useDecoded: true });

export const clearPaymentData = () => ({
  type: 'CLEAR_PAYMENT'
});

export const AddPayment = (formData) =>
  createApiAction({ url: '/buskes/AddPayment', method: 'post', formData, type: 'SUCCESS_MESSAGE', isPost: true });

export const GetPaymentList = (formData) =>
  createApiAction({ url: '/buskes/GetPaymentList', method: 'get', formData, type: 'PAYMENT_LIST', useDecoded: true });

export const GetPaymentData = (formData) =>
  createApiAction({ url: '/buskes/GetPaymentData', method: 'get', formData, type: 'PAYMENT_DATA', useDecoded: true });

export const GetPaymentPreview = (formData) =>
  createApiAction({ url: '/buskes/GetPaymentPreview', method: 'get', formData, type: 'PAYMENT_DATA', useDecoded: true });

export const clearReceiptData = () => ({
  type: 'CLEAR_RECEIPT'
});

export const AddReceipt = (formData) =>
  createApiAction({ url: '/buskes/AddReceipt', method: 'post', formData, type: 'SUCCESS_MESSAGE', isPost: true });

export const GetReceiptList = (formData) =>
  createApiAction({ url: '/buskes/GetReceiptList', method: 'get', formData, type: 'RECEIPT_LIST', useDecoded: true });

export const GetReceiptData = (formData) =>
  createApiAction({ url: '/buskes/GetReceiptData', method: 'get', formData, type: 'RECEIPT_DATA', useDecoded: true });

export const GetReceiptPreview = (formData) =>
  createApiAction({ url: '/buskes/GetReceiptPreview', method: 'get', formData, type: 'RECEIPT_DATA', useDecoded: true });

export const GetCustomerOutstandingPaymentData = (formData) =>
  createApiAction({ url: '/buskes/GetCustomerOutstandingPaymentData', method: 'get', formData, type: 'CUSTOMER_DATA', useDecoded: true });

export const GetCustomerOutstandingReceiptData = (formData) =>
  createApiAction({ url: '/buskes/GetCustomerOutstandingReceiptData', method: 'get', formData, type: 'CUSTOMER_DATA', useDecoded: true });

export const GetOutstandingPayables = (formData) =>
  createApiAction({ url: '/buskes/GetOutstandingPayables', method: 'get', formData, type: 'OUTSTANDING_PAYABLE_LIST', useDecoded: true });

export const GetOutstandingReceivables = (formData) =>
  createApiAction({ url: '/buskes/GetOutstandingReceivables', method: 'get', formData, type: 'OUTSTANDING_RECEIVABLE_LIST', useDecoded: true });

export const GetDealerTransactionDetails = (formData) =>
  createApiAction({ url: '/buskes/GetDealerTransactionDetails', method: 'get', formData, type: 'OUTSTANDING_PAYABLE_LIST', useDecoded: true });

export const GetCustomerTransactionDetails = (formData) =>
  createApiAction({ url: '/buskes/GetCustomerTransactionDetails', method: 'get', formData, type: 'OUTSTANDING_RECEIVABLE_LIST', useDecoded: true });

export const GetStockListByPagination = (formData) =>
  createApiAction({ url: '/buskes/GetStockListByPagination', method: 'get', formData, type: 'STOCK_LIST', useDecoded: true });

export const GetBannerList = (formData) =>
  createApiAction({ url: '/buskes/GetBannerList', method: 'get', formData, type: 'BANNER_LIST', useDecoded: true });

export const AddBanner = (formData) =>
  createApiAction({ url: '/buskes/AddBanner', method: 'post', formData, type: 'SUCCESS_MESSAGE', isPost: true });

export const GetFoodDeliveryChargesList = (formData) =>
  createApiAction({ url: '/buskes/GetFoodDeliveryChargesList', method: 'get', formData, type: 'DELIVERY_CHARGES_LIST', useDecoded: true });

export const AddFoodDeliveryCharges = (formData) =>
  createApiAction({ url: '/buskes/AddFoodDeliveryCharges', method: 'post', formData, type: 'SUCCESS_MESSAGE', isPost: true });

export const GetRatingsList = (formData) =>
  createApiAction({ url: '/buskes/GetRatingsList', method: 'get', formData, type: 'RATINGS_LIST', useDecoded: true });

export const AddRatings = (formData) =>
  createApiAction({ url: '/buskes/AddRatings', method: 'post', formData, type: 'SUCCESS_MESSAGE', isPost: true });

export const PublishRatings = (formData) =>
  createApiAction({ url: '/buskes/PublishRatings', method: 'post', formData, type: 'SUCCESS_MESSAGE', isPost: true });

export const OnDayDeliveryAvailability = (formData) =>
  createApiAction({ url: '/buskes/OnDayDeliveryAvailability', method: 'post', formData, type: 'SUCCESS_MESSAGE', isPost: true });

export const GetAddressListById = (formData) =>
  createApiAction({ url: '/buskes/GetAddressListById', method: 'get', formData, type: 'CUSTOMER_ADDRESS_LIST', useDecoded: true });

export const GenerateSubscriptionFoodOrder = (formData) =>
  createApiAction({ url: '/buskes/GenerateSubscriptionFoodOrder', method: 'post', formData, type: 'SUCCESS_MESSAGE', isPost: true });

export const OrderScheduleTimeUpdate = (formData) =>
  createApiAction({ url: '/buskes/OrderScheduleTimeUpdate', method: 'post', formData, type: 'SUCCESS_MESSAGE', isPost: true });

export const DeviceAction = (formData) =>
  createApiAction({ url: '/buskes/DeviceAction', method: 'post', formData, type: 'SUCCESS_MESSAGE', isPost: true });

export const AddDevice = (formData) =>
  createApiAction({ url: '/buskes/AddDevice', method: 'post', formData, type: 'SUCCESS_MESSAGE', isPost: true });

export const AddDesignDevice = (formData) =>
  createApiAction({ url: '/buskes/AddDesignDevice', method: 'post', formData, type: 'SUCCESS_MESSAGE', isPost: true });

export const GetDeviceList = (formData) =>
  createApiAction({ url: '/buskes/GetDeviceList', method: 'get', formData, type: 'DEVICE_LIST', useDecoded: true });

export const GetDesignList = (formData) =>
  createApiAction({ url: '/buskes/GetDesignList', method: 'get', formData, type: 'DESIGN_LIST', useDecoded: true });

export const GetDeviceStatus = (formData) =>
  createApiAction({ url: '/buskes/GetDeviceStatus', method: 'get', formData, type: 'DEVICE_STATUS_DATA', useDecoded: true });
